class ProductDescriptionReadMore {
  constructor(container) {
    this.container = container;
    this.content = container.querySelector('[data-read-more-content]');
    this.button = container.querySelector('[data-read-toggle-button]');
    if (!this.content || !this.button) return;

    this.button.addEventListener('click', () => this.toggle());
    this.updateButtonVisibility();
    window.addEventListener('resize', () => this.updateButtonVisibility(), { passive: true });
  }

  toggle() {
    const isExpanded = this.container.classList.toggle('is-expanded');
    this.button.setAttribute('aria-expanded', String(isExpanded));
    this.button.textContent = isExpanded ? 'Read Less' : 'Read More';
  }

  updateButtonVisibility() {
    if (this.container.classList.contains('is-expanded')) return;
    this.button.hidden = this.content.scrollHeight <= this.content.clientHeight + 1;
  }
}

document.querySelectorAll('[data-product-description-read-more]').forEach((container) => new ProductDescriptionReadMore(container));
